import { Link } from '@tanstack/react-router'
import { format } from 'date-fns'
import { ChevronRightIcon } from 'lucide-react'

import { Card } from '@/components/ui/Card'
import type { Update } from '../types'
import { UpdateKindBadge } from './UpdateKindBadge'

interface UpdateCardProps {
  update: Update
  isNew: boolean
}

export const UpdateCard = ({ update, isNew }: UpdateCardProps) => (
  <Link
    to="/updates/$slug"
    params={{ slug: update.slug }}
    preload="intent"
    className="group block cursor-pointer rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-brand/40"
  >
    <Card className="flex items-center gap-4 p-5 shadow-sm transition-colors group-hover:border-brand/50">
      <div className="min-w-0 flex-1">
        <div className="mb-2 flex items-center gap-3">
          <UpdateKindBadge kind={update.kind} />
          <span className="text-pretty text-xs font-medium text-blue-6 tabular-nums">
            {format(new Date(update.publishedAt), 'MMM d, yyyy')}
          </span>
          {isNew && (
            <span className="flex items-center gap-1.5 text-pretty text-[11px] font-semibold text-brand">
              <span className="h-1.5 w-1.5 rounded-full bg-brand" />
              New
            </span>
          )}
        </div>
        <h3 className="text-pretty font-semibold tracking-tight text-foreground">
          {update.title}
        </h3>
        {update.summary && (
          <p className="mt-1 line-clamp-2 text-pretty text-sm leading-relaxed text-blue-6">
            {update.summary}
          </p>
        )}
      </div>
      <ChevronRightIcon className="h-5 w-5 shrink-0 text-blue-5 transition-transform group-hover:translate-x-0.5 group-hover:text-brand" />
    </Card>
  </Link>
)
